import { type Theme } from "@mui/material"
import { SimpleWidgetCardTheme } from "../../../definitions/components.types"
import { simpleWidgetCardClasses } from "../../../themeTypes"

export const createSimpleWidgetCardTheme = (theme: Theme): SimpleWidgetCardTheme => ({
    styleOverrides: {
        card: {
            padding: "0.75em",
            gap: theme.spacing(1.5),
        },
    },
    variants: [
        {
            props: { widgetVariant: "dashboard" },
            style: {
                padding: ".25em",
                [`.${simpleWidgetCardClasses.card}`]: {
                    border: "0px",
                    [`.${simpleWidgetCardClasses.content}`]: {
                        padding: 0,
                    },
                    [`.${simpleWidgetCardClasses.actions}`]: {
                        padding: 0,
                    },
                },
            },
        },
    ],
})
